import React, { useState } from 'react';
import automatedPaymentService from '../../../services/automatedPaymentService';

const BillingNotificationsPanel = ({ notifications, onRefresh }) => {
  const [filter, setFilter] = useState('all');
  const [showSentOnly, setShowSentOnly] = useState(false);

  const filteredNotifications = notifications?.filter(notification => {
    if (filter !== 'all' && notification?.notificationType !== filter) return false;
    if (showSentOnly && !notification?.isSent) return false;
    return true;
  });

  const getNotificationBadge = (type) => {
    const display = automatedPaymentService?.getNotificationTypeDisplay(type);
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-semibold ${display?.color}`}>
        {display?.icon} {display?.label}
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleString('en-PG', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleSendNotification = async (notificationId) => {
    try {
      await automatedPaymentService?.sendBillingNotification(notificationId);
      alert('Notification sent successfully');
      onRefresh();
    } catch (error) {
      alert(`Failed to send notification: ${error?.message}`);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between">
          <h2 className="text-xl font-bold text-gray-900">Billing Notifications</h2>
          <div className="flex items-center gap-4">
            <select
              value={filter}
              onChange={(e) => setFilter(e?.target?.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Types</option>
              <option value="payment_success">Payment Success</option>
              <option value="payment_failed">Payment Failed</option>
              <option value="payment_retry">Payment Retry</option>
              <option value="trial_expiring">Trial Expiring</option>
              <option value="trial_expired">Trial Expired</option>
              <option value="payment_method_required">Payment Method Required</option>
            </select>
            <label className="flex items-center gap-2 text-sm text-gray-700">
              <input
                type="checkbox"
                checked={showSentOnly}
                onChange={(e) => setShowSentOnly(e?.target?.checked)}
                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
              Sent Only
            </label>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Type
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Subject
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Recipient
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Created
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredNotifications?.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                  No notifications found
                </td>
              </tr>
            ) : (
              filteredNotifications?.map((notification) => (
                <tr key={notification?.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    {getNotificationBadge(notification?.notificationType)}
                  </td>
                  <td className="px-6 py-4">
                    <div className="text-sm font-medium text-gray-900">
                      {notification?.subject}
                    </div>
                    <div className="text-sm text-gray-500 truncate max-w-xs">
                      {notification?.message}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {notification?.recipientEmail}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {notification?.isSent ? (
                      <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                        ✅ Sent
                      </span>
                    ) : (
                      <span className="px-3 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">
                        ⏳ Pending
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm text-gray-900">
                      {formatDate(notification?.createdAt)}
                    </div>
                    {notification?.sentAt && (
                      <div className="text-xs text-gray-500">
                        Sent: {formatDate(notification?.sentAt)}
                      </div>
                    )}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm">
                    {!notification?.isSent && (
                      <button
                        onClick={() => handleSendNotification(notification?.id)}
                        className="text-blue-600 hover:text-blue-800 font-medium"
                      >
                        Send Now
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BillingNotificationsPanel;
